const prefix = 'orderSim';

export const CREATE = `${prefix}/CREATE`;
export const FETCH_PRODUCTS = `${prefix}/FETCH_PRODUCTS`;
